import React, { useState } from "react";
import { Link } from "react-router-dom";
import LeftMenu from "../Components/LeftMenu";
import { useIntl } from "react-intl";
import logoDark from "../../../../_metronic/_assets/img/logoDark.png";
import LoginTypeModal from "../Components/LoginTypeModal";

const driverIcon = (
  <svg
    width="191"
    height="191"
    viewBox="0 0 191 191"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_135_247)">
      <rect
        width="191"
        height="191"
        rx="95.5"
        fill="#E64110"
        fillOpacity="0.1"
      />
      <path
        d="M120.609 153.188H104.672L96.7031 158.5L86.0781 155.844L75.4531 158.5L67.4844 153.188H51.5469C39.8062 153.188 30.2969 162.697 30.2969 174.438V193.031H86.0781H141.859V174.438C141.859 162.697 132.35 153.188 120.609 153.188Z"
        fill="#E64110"
      />
      <path
        d="M147.169 153.188C150.117 153.188 152.481 155.552 152.481 158.5C152.481 161.422 150.117 163.812 147.169 163.812C144.247 163.812 141.856 161.422 141.856 158.5C141.856 155.552 144.247 153.188 147.169 153.188Z"
        fill="#AAB2BD"
      />
      <path
        d="M147.17 153.188C144.248 153.188 141.857 155.552 141.857 158.5C141.857 161.422 144.248 163.812 147.17 163.812C150.118 163.812 152.482 161.422 152.482 158.5C152.482 155.552 150.118 153.188 147.17 153.188ZM124.166 145.219H170.173C172.191 148.698 173.437 152.683 173.679 156.959C161.62 160.386 152.745 171.383 152.482 184.505V184.531C150.782 184.877 149.002 185.062 147.17 185.062C145.337 185.062 143.557 184.877 141.857 184.531C141.645 171.383 132.746 160.386 120.66 156.959C120.899 152.683 122.148 148.698 124.166 145.219Z"
        fill="#545C66"
      />
      <path
        d="M112.638 158.5C112.638 156.694 112.771 154.914 113.036 153.188C115.586 136.639 129.903 123.969 147.169 123.969C166.241 123.969 181.7 139.428 181.7 158.5C181.7 177.572 166.241 193.031 147.169 193.031C128.097 193.031 112.638 177.572 112.638 158.5ZM120.606 158.5C120.606 171.33 129.744 182.061 141.856 184.531C143.556 184.877 145.336 185.062 147.169 185.062C149.002 185.062 150.781 184.877 152.481 184.531C164.594 182.061 173.731 171.33 173.731 158.5C173.731 157.969 173.705 157.464 173.678 156.959C173.437 152.683 172.188 148.698 170.172 145.219C165.577 137.277 156.997 131.938 147.169 131.938C137.341 131.938 128.761 137.277 124.166 145.219C122.147 148.698 120.901 152.683 120.66 156.959C120.633 157.464 120.606 157.969 120.606 158.5Z"
        fill="#656D78"
      />
      <path
        d="M125.922 70.8438V86.7812L115.297 76.1562C115.297 76.1562 102.016 84.125 86.0781 84.125C70.1406 84.125 56.8594 76.1562 56.8594 76.1562L46.2344 86.7812V73.5C46.2344 54.4016 61.6672 38.9688 80.7656 38.9688H107.328V52.25C117.608 52.25 125.922 60.5641 125.922 70.8438Z"
        fill="#965353"
      />
      <path
        d="M125.922 86.7812V70.8438C125.922 60.5641 117.608 52.25 107.328 52.25V38.9688H96.7031V52.25C96.7031 58.1177 101.46 62.875 107.328 62.875C111.722 62.875 115.297 66.4503 115.297 70.8438V76.1562L125.922 86.7812Z"
        fill="#844747"
      />
      <path
        d="M125.922 86.7812V102.719C125.922 118.019 117.316 131.3 104.672 137.967C99.1203 140.892 92.7984 142.562 86.0781 142.562C79.3578 142.562 73.0359 140.889 67.4844 137.967C54.8406 131.3 46.2344 118.019 46.2344 102.719V86.7812L56.8594 76.1562C56.8594 76.1562 70.1406 84.125 86.0781 84.125C102.016 84.125 115.297 76.1562 115.297 76.1562L125.922 86.7812Z"
        fill="#EAC6BB"
      />
      <path
        d="M115.297 76.1562L115.287 76.1616V102.719C115.287 118.019 106.68 131.3 94.0367 137.967C89.9779 140.105 85.4995 141.564 80.7607 142.201C82.5006 142.432 84.2723 142.562 86.0786 142.562C92.7989 142.562 99.1207 140.889 104.672 137.967C117.316 131.3 125.922 118.019 125.922 102.719V86.7812L115.297 76.1562Z"
        fill="#D3B1A9"
      />
      <path
        d="M104.672 137.967V153.188L96.7031 158.5L86.0781 155.844L75.4531 158.5L67.4844 153.188V137.967C73.0359 140.892 79.3578 142.563 86.0781 142.563C92.7984 142.563 99.1203 140.889 104.672 137.967Z"
        fill="#CF3507"
      />
    </g>
    <defs>
      <clipPath id="clip0_135_247">
        <rect width="191" height="191" rx="95.5" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const carrierIcon = (
  <svg
    width="191"
    height="191"
    viewBox="0 0 191 191"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_135_249)">
      <rect
        width="191"
        height="191"
        rx="95.5"
        fill="#E64110"
        fillOpacity="0.1"
      />
      <path
        d="M170.95 79.4751V161.975H160.95V141.975L155.95 136.975V86.9751H35.9502V121.975C33.1752 121.975 30.9502 124.2 30.9502 126.975V161.975H20.9502V79.4751L91.1502 47.9751C92.6502 47.3251 94.3002 46.9751 95.9502 46.9751C97.5752 46.9751 99.2252 47.3251 100.725 47.9751L170.95 79.4751Z"
        fill="#121D2F"
      />
      <path
        d="M155.95 86.9751V136.975L150.95 131.975H140.95V96.9751H130.95H120.95H110.95H100.95H90.9502H80.9502H70.9502H60.9502H50.9502V121.975H35.9502V86.9751H155.95Z"
        fill="#E6E9ED"
      />
      <path
        d="M115.95 76.9751C118.712 76.9751 120.95 74.7365 120.95 71.9751C120.95 69.2137 118.712 66.9751 115.95 66.9751C113.189 66.9751 110.95 69.2137 110.95 71.9751C110.95 74.7365 113.189 76.9751 115.95 76.9751Z"
        fill="#E6371F"
      />
      <path
        d="M95.9502 76.9751C98.7116 76.9751 100.95 74.7365 100.95 71.9751C100.95 69.2137 98.7116 66.9751 95.9502 66.9751C93.1888 66.9751 90.9502 69.2137 90.9502 71.9751C90.9502 74.7365 93.1888 76.9751 95.9502 76.9751Z"
        fill="#E6371F"
      />
      <path
        d="M75.9502 76.9751C78.7116 76.9751 80.9502 74.7365 80.9502 71.9751C80.9502 69.2137 78.7116 66.9751 75.9502 66.9751C73.1888 66.9751 70.9502 69.2137 70.9502 71.9751C70.9502 74.7365 73.1888 76.9751 75.9502 76.9751Z"
        fill="#E6371F"
      />
      <path d="M51 97H111V122H51V97Z" fill="#D3A06C" />
      <path d="M111 97H141V132H111V97Z" fill="#D3A06C" />
      <path d="M120.95 96.9751H130.95V106.975H120.95V96.9751Z" fill="#B27946" />
      <path
        d="M90.9502 96.9751H100.95V106.975H90.9502V96.9751Z"
        fill="#B27946"
      />
      <path
        d="M60.9502 96.9751H70.9502V106.975H60.9502V96.9751Z"
        fill="#B27946"
      />
      <path
        d="M125.95 166.975C124.2 166.975 122.525 167.275 120.95 167.825V131.975H140.95H150.95L155.95 136.975L160.95 141.975V161.975V176.975H140.075C138.05 171.15 132.475 166.975 125.95 166.975Z"
        fill="#FC6E51"
      />
      <path
        d="M120.95 167.825C116.675 169.325 113.3 172.7 111.8 176.975H70.0752C68.0502 171.15 62.4752 166.975 55.9502 166.975C49.4002 166.975 43.8502 171.15 41.8002 176.975H30.9502V161.975V126.975C30.9502 124.2 33.1752 121.975 35.9502 121.975H50.9502H80.9502H110.95H115.95C118.7 121.975 120.95 124.2 120.95 126.975V131.975V167.825Z"
        fill="#E6371F"
      />
      <path
        d="M103.825 145.65C105.15 146.475 105.95 147.9 105.95 149.475C105.95 151.025 105.15 152.475 103.825 153.3L85.9502 164.475V156.975H40.9502V141.975H85.9502V134.475L103.825 145.65Z"
        fill="url(#paint0_linear_135_249)"
      />
      <path
        d="M163.45 186.975H140.075C140.65 185.425 140.95 183.725 140.95 181.975C140.95 180.225 140.65 178.55 140.075 176.975H160.95H163.45C164.825 176.975 165.95 178.075 165.95 179.475V184.475C165.95 185.85 164.825 186.975 163.45 186.975Z"
        fill="#CCD1D9"
      />
      <path
        d="M110.95 181.975C110.95 183.725 111.25 185.425 111.825 186.975H111.8H70.0752C70.6502 185.425 70.9502 183.725 70.9502 181.975C70.9502 180.225 70.6502 178.55 70.0752 176.975H111.8C111.25 178.55 110.95 180.225 110.95 181.975Z"
        fill="#CCD1D9"
      />
      <path
        d="M41.8252 186.975H35.9502C33.1752 186.975 30.9502 184.725 30.9502 181.975V176.975H41.8002C41.2502 178.55 40.9502 180.225 40.9502 181.975C40.9502 183.725 41.2502 185.425 41.8252 186.975Z"
        fill="#CCD1D9"
      />
      <path
        d="M111.8 176.975C113.3 172.7 116.675 169.325 120.95 167.825C122.525 167.275 124.2 166.975 125.95 166.975C132.475 166.975 138.05 171.15 140.075 176.975C140.65 178.55 140.95 180.225 140.95 181.975C140.95 183.725 140.65 185.425 140.075 186.975C138.025 192.8 132.475 196.975 125.95 196.975C119.425 196.975 113.875 192.8 111.825 186.975C111.25 185.425 110.95 183.725 110.95 181.975C110.95 180.225 111.25 178.55 111.8 176.975Z"
        fill="#969FAA"
      />
      <path
        d="M41.8002 176.975C43.8502 171.15 49.4002 166.975 55.9502 166.975C62.4752 166.975 68.0502 171.15 70.0752 176.975C70.6502 178.55 70.9502 180.225 70.9502 181.975C70.9502 183.725 70.6502 185.425 70.0752 186.975C68.0252 192.8 62.4752 196.975 55.9502 196.975C49.4252 196.975 43.8752 192.8 41.8252 186.975C41.2502 185.425 40.9502 183.725 40.9502 181.975C40.9502 180.225 41.2502 178.55 41.8002 176.975Z"
        fill="#969FAA"
      />
      <path
        d="M125.95 186.975C128.712 186.975 130.95 184.737 130.95 181.975C130.95 179.214 128.712 176.975 125.95 176.975C123.189 176.975 120.95 179.214 120.95 181.975C120.95 184.737 123.189 186.975 125.95 186.975Z"
        fill="#CCD1D9"
      />
      <path
        d="M55.9502 186.975C58.7116 186.975 60.9502 184.737 60.9502 181.975C60.9502 179.214 58.7116 176.975 55.9502 176.975C53.1888 176.975 50.9502 179.214 50.9502 181.975C50.9502 184.737 53.1888 186.975 55.9502 186.975Z"
        fill="#CCD1D9"
      />
      <path
        d="M150.95 146.975V156.975H130.95V141.975H145.95L150.95 146.975Z"
        fill="#E6371F"
      />
      <path
        d="M125.938 174.462C121.802 174.462 118.438 177.827 118.438 181.962C118.438 186.097 121.802 189.462 125.938 189.462C130.073 189.462 133.438 186.097 133.438 181.962C133.438 177.827 130.073 174.462 125.938 174.462ZM125.938 184.462C124.557 184.462 123.438 183.342 123.438 181.962C123.438 180.582 124.557 179.462 125.938 179.462C127.318 179.462 128.438 180.582 128.438 181.962C128.438 183.342 127.315 184.462 125.938 184.462Z"
        fill="#121D2F"
      />
      <path
        d="M55.9375 174.462C51.8025 174.462 48.4375 177.827 48.4375 181.962C48.4375 186.097 51.8025 189.462 55.9375 189.462C60.0725 189.462 63.4375 186.097 63.4375 181.962C63.4375 177.827 60.0725 174.462 55.9375 174.462ZM55.9375 184.462C54.5575 184.462 53.4375 183.342 53.4375 181.962C53.4375 180.582 54.5575 179.462 55.9375 179.462C57.3175 179.462 58.4375 180.582 58.4375 181.962C58.4375 183.342 57.315 184.462 55.9375 184.462Z"
        fill="#121D2F"
      />
      <path
        d="M146.972 139.462H128.438V159.462H153.437V145.927L146.972 139.462ZM148.437 154.462H133.437V144.462H144.903L148.437 147.997V154.462Z"
        fill="#121D2F"
      />
      <path
        d="M173.437 164.462V77.8449L101.737 45.7024C98.1075 44.0824 93.775 44.0799 90.135 45.7049L18.4375 77.8449V164.462H28.4375V181.962C28.4375 186.097 31.8025 189.462 35.9375 189.462H40.15C42.965 195.365 48.975 199.462 55.9375 199.462C62.9 199.462 68.9075 195.365 71.725 189.462H110.15C112.965 195.365 118.975 199.462 125.937 199.462C132.9 199.462 138.907 195.365 141.725 189.462H163.44C166.197 189.462 168.44 187.22 168.44 184.462V179.462C168.44 176.705 166.197 174.462 163.44 174.462H163.437V164.462H173.437ZM23.4375 159.462V81.0825L92.18 50.2699C94.54 49.2149 97.3425 49.2174 99.695 50.2674L168.437 81.0825V159.465H163.437V140.93L158.437 135.93V84.4625H33.4375V119.925C30.535 120.96 28.4375 123.71 28.4375 126.965V159.465H23.4375V159.462ZM110.15 174.462H71.725C68.91 168.56 62.9 164.462 55.9375 164.462C48.975 164.462 42.9675 168.56 40.15 174.462H33.4375V126.962C33.4375 125.582 34.5575 124.462 35.9375 124.462H115.937C117.317 124.462 118.437 125.582 118.437 126.962V166.175C114.812 167.905 111.88 170.837 110.15 174.462ZM63.4375 99.4625H68.4375V104.462H63.4375V99.4625ZM73.4375 109.462V99.4625H78.4375V119.462H53.4375V99.4625H58.4375V109.462H73.4375ZM93.4375 99.4625H98.4375V104.462H93.4375V99.4625ZM103.437 109.462V99.4625H108.437V119.462H83.4375V99.4625H88.4375V109.462H103.437ZM115.937 119.462H113.437V99.4625H118.437V109.462H133.437V99.4625H138.437V129.462H123.437V126.962C123.437 122.827 120.072 119.462 115.937 119.462ZM123.437 99.4625H128.437V104.462H123.437V99.4625ZM113.437 94.4625H108.437H83.4375H78.4375H48.4375V119.462H38.4375V89.4625H153.437V130.927L151.972 129.462H143.437V94.4625H113.437ZM35.9375 184.462C34.5575 184.462 33.4375 183.342 33.4375 181.962V179.462H38.6375C38.52 180.282 38.4375 181.112 38.4375 181.962C38.4375 182.812 38.52 183.642 38.6375 184.462H35.9375ZM55.9375 194.462C49.045 194.462 43.4375 188.855 43.4375 181.962C43.4375 175.07 49.045 169.462 55.9375 169.462C62.83 169.462 68.4375 175.07 68.4375 181.962C68.4375 188.855 62.8275 194.462 55.9375 194.462ZM73.2375 184.462C73.355 183.642 73.4375 182.812 73.4375 181.962C73.4375 181.112 73.355 180.282 73.2375 179.462H108.637C108.52 180.282 108.437 181.112 108.437 181.962C108.437 182.812 108.52 183.642 108.637 184.462H73.2375ZM125.937 194.462C119.045 194.462 113.437 188.855 113.437 181.962C113.437 175.07 119.045 169.462 125.937 169.462C132.83 169.462 138.437 175.07 138.437 181.962C138.437 188.855 132.827 194.462 125.937 194.462ZM163.44 184.462H143.237C143.355 183.642 143.437 182.812 143.437 181.962C143.437 181.112 143.355 180.282 143.237 179.462H163.44V184.462ZM141.722 174.462C138.907 168.56 132.897 164.462 125.935 164.462C125.085 164.462 124.255 164.545 123.435 164.662V134.462H149.9L158.435 142.997V174.462H141.722Z"
        fill="#121D2F"
      />
      <path
        d="M115.938 79.4624C120.073 79.4624 123.438 76.0974 123.438 71.9624C123.438 67.8274 120.073 64.4624 115.938 64.4624C111.802 64.4624 108.438 67.8274 108.438 71.9624C108.438 76.0974 111.8 79.4624 115.938 79.4624ZM115.938 69.4624C117.318 69.4624 118.438 70.5824 118.438 71.9624C118.438 73.3424 117.318 74.4624 115.938 74.4624C114.557 74.4624 113.438 73.3424 113.438 71.9624C113.438 70.5824 114.557 69.4624 115.938 69.4624Z"
        fill="#121D2F"
      />
      <path
        d="M95.9375 79.4624C100.073 79.4624 103.437 76.0974 103.437 71.9624C103.437 67.8274 100.073 64.4624 95.9375 64.4624C91.8025 64.4624 88.4375 67.8274 88.4375 71.9624C88.4375 76.0974 91.8 79.4624 95.9375 79.4624ZM95.9375 69.4624C97.3175 69.4624 98.4375 70.5824 98.4375 71.9624C98.4375 73.3424 97.3175 74.4624 95.9375 74.4624C94.5575 74.4624 93.4375 73.3424 93.4375 71.9624C93.4375 70.5824 94.5575 69.4624 95.9375 69.4624Z"
        fill="#121D2F"
      />
      <path
        d="M75.9375 79.4624C80.0725 79.4624 83.4375 76.0974 83.4375 71.9624C83.4375 67.8274 80.0725 64.4624 75.9375 64.4624C71.8025 64.4624 68.4375 67.8274 68.4375 71.9624C68.4375 76.0974 71.8 79.4624 75.9375 79.4624ZM75.9375 69.4624C77.3175 69.4624 78.4375 70.5824 78.4375 71.9624C78.4375 73.3424 77.3175 74.4624 75.9375 74.4624C74.5575 74.4624 73.4375 73.3424 73.4375 71.9624C73.4375 70.5824 74.5575 69.4624 75.9375 69.4624Z"
        fill="#121D2F"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_135_249"
        x1="40.9501"
        y1="149.475"
        x2="105.95"
        y2="149.475"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EC621C" />
        <stop offset="0.37" stopColor="#EC601C" />
        <stop offset="0.58" stopColor="#EB571D" />
        <stop offset="0.75" stopColor="#E9491E" />
        <stop offset="0.91" stopColor="#E73520" />
        <stop offset="1" stopColor="#E52521" />
      </linearGradient>
      <clipPath id="clip0_135_249">
        <rect width="191" height="191" rx="95.5" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

function AccountTypeSelector() {
  const intl = useIntl();
  const [loginTypeModal, setLoginTypeModal] = useState(false);
  return (
    <div className="d-flex flex-column flex-root position-relative form-background">
      {loginTypeModal && (
        <LoginTypeModal closeModal={() => setLoginTypeModal(false)} />
      )}
      <div className="login login-1 login-signin-on d-flex flex-column">
        <div className="d-flex flex-column flex-lg-row h-100 form-container">
          <div className="d-flex flex-column flex-row-fluid position-relative form-area">
            <div className="d-flex flex-column-fluid align-items-stretch justify-content-start">
              <div className="login-form login-signin d-flex align-items-stretch justify-content-center flex-column">
                <div className="d-flex flex-column align-items-center justify-content-center">
                  <img
                    src={logoDark}
                    alt="sectran"
                    className="account-select-logo"
                  />
                  <span className="account-select">
                    {intl.formatMessage({ id: "ACCOUNT_TYPE_DESC" })}
                  </span>
                  <div className="account-select-icon-container">
                    <div
                      onClick={() => setLoginTypeModal(true)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex align-items-center justify-content-center flex-column">
                        <div className="svg-container">{driverIcon}</div>
                        <span className="account-select">
                          {intl.formatMessage({ id: "DRIVER" })}
                        </span>
                      </div>
                    </div>
                    <Link to={"/auth/carrier-registration"}>
                      <div className="d-flex align-items-center justify-content-center flex-column">
                        <div className="svg-container">{carrierIcon}</div>
                        <span className="account-select">
                          {intl.formatMessage({
                            id: "ACCOUNT_TYPE_SELECT_CARRIER"
                          })}
                        </span>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <LeftMenu
            boxes={null}
            faq={null}
            imageType={"accountSelector"}
            logoDisabled={true}
            languageMenu
          />
        </div>
      </div>
    </div>
  );
}

export default AccountTypeSelector;
